import { useTranslation } from 'react-i18next';

export default function AboutPreview() {
  const { t } = useTranslation();

  const values = [
    { icon: 'ri-shield-check-line', title: t('ap_val1_t'), desc: t('ap_val1_d') },
    { icon: 'ri-star-line', title: t('ap_val2_t'), desc: t('ap_val2_d') },
    { icon: 'ri-time-line', title: t('ap_val3_t'), desc: t('ap_val3_d') },
    { icon: 'ri-heart-line', title: t('ap_val4_t'), desc: t('ap_val4_d') },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://public.readdy.ai/ai/img_res/1f6dc451ffaa50d6b1fc75fe70f495ca.jpg"
                alt="Equipo de limpieza profesional"
                className="w-full h-72 object-cover object-top rounded-2xl"
              />
              <div className="flex flex-col gap-4 mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20cleaning%20equipment%20supplies%20green%20blue%20bottles%20mop%20bucket%20organized%20professional%20cleaning%20kit%20on%20bright%20white%20background%20commercial%20cleaning%20supplies&width=400&height=280&seq=about002&orientation=landscape"
                  alt="Equipos de limpieza profesional"
                  className="w-full h-36 object-cover object-top rounded-2xl"
                />
                <div className="bg-gradient-to-br from-brand-green to-brand-blue rounded-2xl p-6 text-white text-center">
                  <p className="font-heading font-bold text-5xl">24h</p>
                  <p className="text-white/80 text-sm mt-1">{t('hero_stat2')}</p>
                </div>
              </div>
            </div>
            {/* Badge */}
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-2xl px-6 py-3 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-green-light">
                <i className="ri-award-line text-brand-green-dark text-xl" />
              </div>
              <div>
                <p className="font-semibold text-brand-blue-dark text-sm">{t('ap_clients')}</p>
                <p className="text-gray-400 text-xs">{t('ap_area')}</p>
              </div>
            </div>
          </div>

          {/* Text */}
          <div className="pt-8 lg:pt-0">
            <span className="text-brand-green font-semibold text-sm uppercase tracking-wider">{t('ap_eyebrow')}</span>
            <h2 className="font-heading font-bold text-brand-blue-dark text-4xl mt-2 mb-6 leading-tight">
              {t('ap_heading')} <span className="text-brand-green">{t('ap_heading_accent')}</span> {t('ap_heading_end')}
            </h2>
            <p className="text-gray-500 leading-relaxed mb-6 text-sm">{t('ap_p1')}</p>
            <p className="text-gray-500 leading-relaxed mb-8 text-sm">{t('ap_p2')}</p>

            {/* Values */}
            <div className="grid grid-cols-2 gap-4">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-brand-green-light/50 flex-shrink-0">
                    <i className={`${v.icon} text-brand-green-dark`} />
                  </div>
                  <div>
                    <p className="font-semibold text-brand-blue-dark text-sm">{v.title}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{v.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="/nosotros"
              className="inline-flex items-center gap-2 mt-8 bg-brand-blue-dark hover:bg-brand-blue text-white font-semibold px-7 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              {t('ap_cta')} <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
